
import React from 'react';

import commerInfoMocked from './commerInfoMocked.json'
import ProductFeatureDetail from './ProductFeatureDetail'
import { getFusionFeatures } from '../Utils/index';
import { VARIANT } from '../index'
/**
 * compnente funcional para pintar los atributps de un fusión en el productitem
 * @param {object} commerInfo información de cada atributo
 * @returns {jsx}
 */
export const FusionFeatures = ({
  commerInfo,
  variant,
  handleClickIncludes,
  calculatedTaggingInfo,
  modifierSmartphoneIncludes,
  hiredProductWeights,
  dicRepoProductWeights,
  hideColors,
  productHiredIsOldCatalogue,
  hasClientAlreadyDevice,
}) => {
  const {
    tv, movil, internet, smartPhone,
  } = getFusionFeatures(commerInfo);

  const featureList = [
    { feature: smartPhone, featureType: '--include-smartphone' },
    { feature: tv, featureType: '--tv' },
    { feature: movil, featureType: '--mobile-line' },
    { feature: internet, featureType: '--internet' },
  ];


  const uncatalogedFeature = { feature: commerInfoMocked, featureType: '--upgradePrice' };
  if ((productHiredIsOldCatalogue || hasClientAlreadyDevice === false)
    && variant === VARIANT.HIRED) {
    featureList.push(uncatalogedFeature)
  }

  return (
    <div className="FusionFeatures">
      {featureList && (
        featureList.map((eachFeature) => {
          if (eachFeature.feature) {
            return (
              <ProductFeatureDetail
                feature={eachFeature.feature}
                variant={variant}
                handleClickIncludes={handleClickIncludes}
                calculatedTaggingInfo={calculatedTaggingInfo}
                modifierSmartphoneIncludes={modifierSmartphoneIncludes}
                hiredProductWeights={hiredProductWeights}
                dicRepoProductWeights={dicRepoProductWeights}
                hideColors={hideColors}
                featureType={eachFeature.featureType}
              />
            )
          }
          return null;
        })
      )}
    </div>

  )
}
export default FusionFeatures
